import "./ConfirmationComponent.scss";
import {useEffect, useState} from 'react';
import {Communications} from "../../services";
import {IConfirmationConfig} from "../../models/confirmation.model";
import ModalComponent from "../modal/ModalComponent";
import ButtonComponent from "../button-component/ButtonComponent";

// interface ConfirmationComponentProps {
//
// }

const ConfirmationComponent = () => {

    const [open, setOpen] = useState(false);
    const [config, setConfig] = useState<IConfirmationConfig | null>(null);
    const [promise, setPromise] = useState<{ resolve: any, reject: any } | null>(null);

    useEffect(() => {
        const subscription = Communications.ConfirmStateSubject.subscribe(({config, promise}) => {
            setPromise(promise);
            setConfig(config);
            openConfirmationDialog();

        });
        return () => {
            subscription.unsubscribe();
        };
    }, []);

    const openConfirmationDialog = () => {
        setOpen(true);
    };

    const confirm = () => {
        promise?.resolve();
        closeConfirmationDialog();
    };

    const cancel = () => {
        promise?.reject();
        closeConfirmationDialog();
    };

    const closeConfirmationDialog = () => {
        setOpen(false);
    };


    return (
        <ModalComponent
            title={config?.confirmationTitle || ''}
            open={open}
            onCancel={closeConfirmationDialog}
            keyboard={true}
            centered={true}
            closeIcon={true}
            footer={[
                <ButtonComponent
                    onClick={cancel}
                    size={'small'}
                    variant={'outlined'}
                    color={'default'}
                    className={"pdd-16 confirmation-dialog-no-btn full-width"}
                >
                    {config?.no?.text || 'No'}
                </ButtonComponent>,
                <ButtonComponent
                    onClick={confirm}
                    size={'small'}
                    variant={'solid'}
                    color={config?.type === 'error' ? 'danger' : 'primary'}
                    className={"pdd-16 confirmation-dialog-yes-btn full-width"}
                >
                    {config?.yes?.text || 'Yes'}
                </ButtonComponent>
            ]}
        >
            <div
                className={`confirmation-dialog-container`}>

                {config?.image && <div className="confirmation-dialog-image-container">
                    <div className={"confirmation-dialog-image"}>
                        {(typeof (config.image) === 'string') &&
                            <img src={config.image} alt={config?.confirmationTitle}/>}
                        {(typeof (config.image) !== 'string') && <config.image/>}
                    </div>
                </div>}
                <div className="confirmation-dialog-content-wrapper">
                    {/*<div className={"confirmation-dialog-title"}>*/}
                    {/*    {config?.confirmationTitle || 'Confirm ?'}*/}
                    {/*</div>*/}
                    <div className="confirmation-dialog-sub-title">{config?.confirmationSubTitle}</div>
                    <div
                        className="confirmation-dialog-sub-description mrg-top-25"
                        // @ts-expect-error
                        dangerouslySetInnerHTML={{__html: config?.confirmationDescription}}
                    />
                </div>
            </div>
        </ModalComponent>
    );
};

export default ConfirmationComponent;

// ****************************** USAGE ****************************** //

// CommonService.onConfirm({
// closeOnBackdropClick: true,
// closeOnEsc: false,
// confirmationTitle: "Confirm",
// confirmationSubTitle: "Are you sure ?",
// confirmationDescription: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ratione, repellendus! ",
// direction: "left",
// yes: {
//     color: "primary",
//     text: "Agree",
//     variant: "contained"
// },
// no: {
//     color: "error",
//     text: "DisAgree",
//     variant: "outlined"
// }
// })
//     .then(() => {
//         setIsTnCModalOpened(true);
//     }).catch(() => {
//     console.log('rejected');
// });

// ****************************** USAGE ****************************** //
